<script setup>

import { ref, computed, watch } from 'vue';

const { typeObjet, selectionne } = defineProps({
  typeObjet: Object,
  selectionne: Boolean
})

const composant = ref(null);

const typeObjetEnErreur = computed(() => {
	return typeObjet.champs.some(champ => champ.formuleEnErreur)
		|| typeObjet.population?.formuleEnErreur;
});

watch(() => selectionne, (sel) => {
	if (sel) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

function commencerGlisserDeplacer(event) {
	const donneesTransfert = {
		type: 'TYPE_OBJET',
		typeObjet: typeObjet
	};
	event.dataTransfer.setData('text/plain', JSON.stringify(donneesTransfert));
	event.dataTransfer.dropEffect = 'copy';
}

</script>

<template>
  <div class="type-objet" 
	ref="composant"
	draggable="true"
	@dragstart="commencerGlisserDeplacer">
		<div class="nom-type-objet">{{ typeObjet.nom }}</div>
		<i v-if="typeObjetEnErreur" class="fa-solid fa-triangle-exclamation icone erreur" v-tooltip="'Type d\'objet en erreur'" />
		<i v-else class="icone invisible" />
	</div>
</template>

<style scoped>

.type-objet {
	display: flex;
	user-select: none;
	padding: 0px 5px;
	align-items: center;
}

.nom-type-objet {
	width: 14rem;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
}

.icone {
	padding: 1px;
	margin: 2px 4px;
	width: 1rem;
	text-align: center;
}

.erreur {
	color: var(--couleur-valeur-en-erreur);
}

</style>